export enum WEventType {
  TABLE_SYNC_EVENT = 'TABLE_SYNC_EVENT',
  BOT_EVENT = 'BOT_EVENT',
  TABLE_EVENT = 'TABLE_EVENT',
  PLAYER_SITTING_OUT_EVENT = 'SITTING_OUT_EVENT',
  PLAYER_EVENT = 'PLAYER_EVENT',
  GAME_FINISH_EVENT = 'GAME_FINISH_EVENT',
  BLIND_EVENT = 'BLIND_EVENT',
  LEAVE_TABLE_EVENT = 'LEAVE_TABLE_EVENT',
  CHAT_EVENT = 'CHAT_EVENT',
  TARGET_CHAT_EVENT = 'TARGET_CHAT_EVENT',
  BOT_ERROR_EVENT = 'BOT_ERROR_EVENT',
  PLAYER_TURN_STARTED_EVENT = 'PLAYER_TURN_STARTED_EVENT',
  PLAYER_INIT_CARDS_EVENT = 'PLAYER_INIT_CARDS_EVENT',
  PLAYER_SIT_EVENT = 'PLAYER_SIT_EVENT',
  REMOVE_TABLE_EVENT = 'REMOVE_TABLE_EVENT',
  CALL_TIME_EVENT = 'CALL_TIME_EVENT',
  BOT_AVAILABLE_GAME_ACTION_EVENT = 'BOT_AVAILABLE_GAME_ACTION_EVENT',
  TABLE_VIEWER_SYNC_EVENT = 'TABLE_VIEWER_SYNC_EVENT',
  WAITLIST_SYNC_EVENT = 'WAITLIST_SYNC_EVENT',
  BOT_WAITING_HOST_EVENT = 'BOT_WAITING_HOST_EVENT',
  BOT_WAITING_HOST_REBUY_EVENT = 'BOT_WAITING_HOST_REBUY_EVENT',
}
